import React from "react";
import Styles from "../../components/Report/Report.module.css";
import { IBillingCycleData } from "../../hooks/patients/useFetchBillingCyclePdf";

interface HeaderProps {
  billingCycleData?: IBillingCycleData | null;
  billingCycleDataLoading?: boolean;
}

const NewReportHeader: React.FC<HeaderProps> = ({
  billingCycleData,
  billingCycleDataLoading,
}) => {
  const formatDate = (dateString: string | undefined) => {
    if (!dateString) return "N/A";
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return "N/A";
      return date.toLocaleDateString("en-US", {
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
      });
    } catch (error) {
      console.error("Error formatting date:", error);
      return "N/A";
    }
  };
  const patientName = billingCycleData?.patientId?.name || "N/A";
  const providerName =
    billingCycleData?.patientId?.billingProviderId?.name || "N/A";
  const clinicName =
    billingCycleData?.patientId?.associatedClinicId?.name || "N/A";
  const dateOfBirth = billingCycleData?.patientId?.dobString || "N/A";

  return (
    <div className={Styles.reportHeaderContainer}>
      <div className={Styles.reportHeaderTop}>
        <div className={Styles.reportLogoSection}>
          <img
            src="/assets/LogoNew_Dark.png"
            alt="Logo"
            className={`${Styles.reportLogo} ${Styles.logoCliniq}`}
          />
        </div>
        <div className={Styles.reportHeaderTitleSection}>
          <h1 className={Styles.reportHeaderTitle}>
            PATIENT SUMMARY REPORT AND ASSESSMENT SCORES
          </h1>
        </div>
        <div className={Styles.reportLogoSection}>
          <img
            src="/assets/logo-dark.png"
            alt="Logo Dark"
            className={Styles.reportLogo}
          />
        </div>
      </div>
      <div className={Styles.patientInfoTable}>
        <div className={Styles.infoRow}>
          <div className={`${Styles.infoCell} ${Styles.infoCellWide}`}>
            <b>Patient:</b> {patientName}
          </div>
          <div className={`${Styles.infoCell} ${Styles.infoCellWide}`}>
            <b>Date of Birth:</b> {dateOfBirth}
          </div>
          <div className={`${Styles.infoCell} ${Styles.infoCellWide}`}>
            <b>Clinic:</b> {clinicName}
          </div>
          <div className={`${Styles.infoCell} ${Styles.infoCellNarrow}`}>
            <b>Provider:</b> {providerName}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewReportHeader;
